interface Props {
  day: Date;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modifiers?: any;
}

function DefaultCalendarDayV2({ day }: Props): JSX.Element {
  return (
    <div className="Calendar-day">
      <div className="Calendar-dayContent">{day.getDate()}</div>
    </div>
  );
}

export default DefaultCalendarDayV2;
